export default {
  methods: {
    clickedCvOther (data) {
      this.create({
        designator: 'position-search-for-cv-modal',
        component_name: 'PositionSearchForCvModal',
        modal_title: 'בחירת משרה לשליחת קו"ח',
        modal_width: 800,
        is_center_modal: true,
        offer: data,
        onPositionSelected: (selectedPosition) => {
          this.openSendCvModal(data, selectedPosition)
        }
      })
    },
    async openSendCvModal (currentOffer, selectedPosition) {
      try {
        const offer = await this.findOrCreateOffer(
          currentOffer.applicant.resource_id || currentOffer.applicant.id,
          selectedPosition.id
        )
        this.create({
          designator: 'send-cv-mode-selection-modal',
          component_name: 'SendCvModeSelectionModal',
          data: offer,
          modal_title: 'בחירת מצב שליחת קורות חיים',
          modal_width: 600,
          is_center_modal: true
        })
      } catch (error) {
        console.error('Error opening CV modal:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בטעינת/יצירת ההצעה' })
      }
    },
    async findOrCreateOffer (applicantId, positionId) {
      try {
        const offers = await this.$network_utils.getResourceOffers({
          resource_type: 'Position',
          resource_id: positionId,
          applicant_id: applicantId,
          per: 1
        })
        if (offers && offers.length > 0) {
          return offers[0]
        }
        const position = await this.$network_utils.getPosition({ id: positionId })
        const applicant = await this.$network_utils.getApplicant({ id: applicantId })
        const virtualOffer = {
          id: `temp_${Date.now()}`,
          applicant: applicant,
          position: position,
          status: { name: 'not_created_yet' },
          message: '',
          is_virtual: true
        }
        return virtualOffer
      } catch (error) {
        console.error('Error finding/creating offer:', error)
        throw error
      }
    }
  }
}
